<script>
    import {ICONS} from '../js/icons.js';
    import Pagination from "../lib/components/Pagination.svelte";
    import {onMount} from "svelte";
    import moment from "moment";
    import backend from "../server.js";
    import Loading from "../lib/components/Loading.svelte";
    import ViewLogs from "../lib/components/modals/trx/ViewLogs.svelte";
    import FindLogs from "../lib/components/modals/trx/FindLogs.svelte";
    import alertify from "alertifyjs";
    import Information from "../lib/components/modals/trx/Information.svelte";
    import {utils, writeFileXLSX} from "xlsx";
    import LogTrace from "../lib/components/modals/trx/LogTrace.svelte";
    import {getClientsForGroup} from "../js/clientCurrencyMap.js";
    let showProvidersDetail = false;
    let isInitialized = false;
    let transations = { list: [] };
    let filters = { page: 1, xpage: 50, winNotZero: true, provider: '', brand: '' };
    let loading = false;
    let exportLoading = false;
    let showTrxLogs = false;
    let showFindLogs = false;
    let showTrxInfo = false;
    let showLogTrace = false;
    let logfilter;
    let tracking = false;
    let trackingAmount = 0; // Valor por defecto
    let onliveTracking = false;
    let liveIntervalId;
    const liveInterval = 10000;
    let timerSeconds = "";
    let timerId;
    let platforms = [];
    let providers = [];
    let providerMap = {};
    let brands = [];
    let categories = [];
    let typesGames=[];
    let transactionInfo;
    let countryBSEP = "EC";
    let summary = [];
    let sessionClientCodes = [];
    let clientOptions = [];
    let clientSearch = '';
    let clientDropdownOpen = false;

    $: filteredClientOptions = clientOptions.filter(c =>
      c.code.toLowerCase().includes(clientSearch.toLowerCase()) ||
      (c.namesite || '').toLowerCase().includes(clientSearch.toLowerCase())
    );

    function selectClient(code) {
        const clientCode = code ?? "";
        clientDropdownOpen = false;
        filters.selectedClient = clientCode;
        filters.client_code = clientCode;
        const opt = clientOptions.find(o => o.code === clientCode);
        clientSearch = opt ? `${opt.namesite} (${opt.code})` : "Todos";
        checkClientEndpoint(clientCode || null);
        listProviders(clientCode || null);
        listCategories(clientCode || null);
        loadSummary();
    }
    async function checkClientEndpoint(clientCode) {
        showProvidersDetail = true;
    }
    $: totals = summary.reduce((acc, r) => {
        acc.sales += Number(r?.sales ?? 0);
        acc.prizes += Number(r?.prizes ?? 0);
        acc.refunds += Number(r?.refunds ?? 0);
        acc.ggr += Number(r?.ggr ?? 0);
        acc.ggrUsd += Number(r?.ggrUsd ?? 0);
        return acc;
    }, { sales: 0, prizes: 0, refunds: 0, ggr: 0, ggrUsd: 0 });

    function getClientCodesFromSession() {
        try {
            const u = JSON.parse(sessionStorage.getItem('user') || '{}');
            if (u.bo_client_codes && u.bo_client_codes.length > 0) return u.bo_client_codes;
            const code = u.client_code || u.currency || '';
            return getClientsForGroup(code);
        } catch {
            return [];
        }
    }
    function getClientCodeFromSession() {
        try {
            const u = JSON.parse(sessionStorage.getItem('user') || '{}');
            return u?.client_code;
        } catch { return null; }
    }
    async function loadSummary() {
        const baseCommon = { from: filters.from, to: filters.to, mode: "A" };
        if (!isDateRangeValid()) {
            alertify.error(`El rango entre Desde y Hasta no puede superar ${MAX_DAYS} días.`);
            enforceMaxRangeFromTo();
            loading = false;
            return;
        }
        let base = { ...baseCommon };
        if (filters.category) base.category = filters.category;
        if (filters.provider) base.provider = filters.provider;
        if (filters.brand) base.brand = filters.brand;
        loading = true;
        try {
            const chosenClient = filters.selectedClient && filters.selectedClient !== "" ? filters.selectedClient : null;
            if (chosenClient) {
                const req = { ...base, clientCode: chosenClient };
                const { data } = await backend.trx.report(req);
                summary = Array.isArray(data) ? data : [];
                summary = summary.map(r => ({
                    ...r,
                    ggr: Number(r.ggr ?? 0),
                    ggrUsd: Number(r.ggrUsd ?? 0)
                }));
                loading = false;
                return;
            }
            if (filters.selectedClient === "") {
                const req = { ...base, clientCode: "" };
                const { data } = await backend.trx.report(req);
                summary = (Array.isArray(data) ? data : []).map(r => ({
                    ...r,
                    ggr: Number(r.ggr ?? 0),
                    ggrUsd: Number(r.ggrUsd ?? 0)
                }));
                loading = false;
                return;
            }
            if (sessionClientCodes.length > 1) {
                const requests = sessionClientCodes.map(cc => {
                    const p = { ...base, clientCode: cc };
                    return backend.trx.report(p)
                        .then(r => ({ code: cc, data: Array.isArray(r?.data) ? r.data : [] }))
                        .catch(e => ({ code: cc, data: [] }));
                });
                const responses = await Promise.all(requests);
                const map = new Map();
                for (const r of responses) {
                    const arr = r.data || [];
                    for (const item of arr) {
                        const key = `${item.siteName || ''}|${item.category || ''}|${item.provider || ''}|${item.brand || ''}|${item.currency || ''}`;
                        const existing = map.get(key);
                        if (!existing) {
                            map.set(key, {
                                siteName: item.siteName,
                                category: item.category,
                                provider: item.provider,
                                brand: item.brand,
                                currency: item.currency,
                                sales: Number(item.sales ?? 0),
                                prizes: Number(item.prizes ?? 0),
                                refunds: Number(item.refunds ?? 0),
                                ggr: Number(item.ggr ?? 0),
                                ggrUsd: Number(item.ggrUsd ?? 0)
                            });
                        } else {
                            existing.sales += Number(item.sales ?? 0);
                            existing.prizes += Number(item.prizes ?? 0);
                            existing.refunds += Number(item.refunds ?? 0);
                            existing.ggr += Number(item.ggr ?? 0);
                            existing.ggrUsd += Number(item.ggrUsd ?? 0);
                            map.set(key, existing);
                        }
                    }
                }
                summary = Array.from(map.values()).map(r => ({
                    ...r,
                    ggr: Number(r.ggr ?? 0),
                    ggrUsd: Number(r.ggrUsd ?? 0)
                }));
                loading = false;
                return;
            }
            const clientCode = getClientCodeFromSession();
            if (clientCode) base.clientCode = clientCode;
            const { data } = await backend.trx.report(base);
            summary = Array.isArray(data) ? data : [];
            summary = summary.map(r => ({
                ...r,
                ggr: Number(r.ggr ?? 0),
                ggrUsd: Number(r.ggrUsd ?? 0)
            }));
        } catch (e) {
            console.error("Error  loadSummary:", e);
            alertify.error("Error al cargar el resumen");
        } finally {
            loading = false;
        }
    }
    async function loadBrands(provider) {
        if (!provider) { brands = []; filters.brand = ''; return; }
        try {
            const resp = await backend.games.listBrands(provider);
            brands = Array.isArray(resp.data) ? resp.data.map(x => x.brand) : [];
        } catch (e) {
            alertify.error('No se pudieron cargar las marcas');
            brands = [];
        }
    }
    const listProviders = async (clientCode = null) => {
        try {
            const activeClientCode = clientCode || getClientCodeFromSession();
            const params = { environment: "public" };
            if (activeClientCode) params.clientId = activeClientCode;
            const resp = await backend.provider.list(params);
            let provsArray = [];
            if (Array.isArray(resp)) provsArray = resp;
            else if (Array.isArray(resp?.providers)) provsArray = resp.providers;
            else if (Array.isArray(resp?.data?.providers)) provsArray = resp.data.providers;
            else if (Array.isArray(resp?.data)) provsArray = resp.data;
            else if (Array.isArray(resp?.providers?.providers)) provsArray = resp.providers.providers;
            provsArray = provsArray || [];
            const collator = new Intl.Collator("es", { sensitivity: "base", numeric: true });
            providers = provsArray
                .map(p => ({
                    id: p.id,
                    name: p.name,
                    code: p.code
                }))
                .sort((a, b) => collator.compare(a.name || "", b.name || ""));
            providerMap = {};
            for (const p of providers) { if (p?.code) providerMap[p.code] = p.name ?? p.code; }
        } catch (e) {
            console.error("Error listando providers:", e);
            providers = [];
            providerMap = {};
        }
    };
    const providerName = (code) => {
        if (!code) return "";
        return providerMap[code] ?? code;
    };
    const fmt = (v) => Number(v ?? 0).toFixed(2);
    const clsBySign = (v) => Number(v ?? 0) <= 0 ? "text-red" : "text-green";
    const MAX_DAYS = 62;
    function parseDateStrict(d) {
        if (!d) return null;
        const m = moment(d, "YYYY-MM-DD", true);
        return m.isValid() ? m : null;
    }
    function enforceMaxRangeFromTo() {
        const mFrom = parseDateStrict(filters.from);
        let mTo = parseDateStrict(filters.to);
        if (!mFrom) return;
        if (!mTo) {
            filters.to = mFrom.format("YYYY-MM-DD");
            return;
        }
        const maxTo = mFrom.clone().add(MAX_DAYS, "days");
        if (mTo.isAfter(maxTo)) {
            filters.to = maxTo.format("YYYY-MM-DD");
            alertify.warning(`Rango máximo ${MAX_DAYS} días. 'Hasta' ajustado a ${filters.to}`);
        }
    }
    function isDateRangeValid() {
        const mFrom = parseDateStrict(filters.from);
        const mTo = parseDateStrict(filters.to);
        if (!mFrom || !mTo) return true;
        const diffDays = mTo.diff(mFrom, "days");
        return diffDays >= 0 && diffDays <= MAX_DAYS;
    }
    const listCategories = async (clientCode = null) => {
        const params = clientCode ? { clientCode } : (getClientCodeFromSession() ? { clientCode: getClientCodeFromSession() } : {});
        const { data } = await backend.games.listCategoriesByClientCode(params);
        categories = (data || []).sort();
    };
    const list = async () => {
        transations.list = [];
        let params = { ...filters, mode: "A" };
        for (const key in params) if (params[key] === "") delete params[key];
        if (!params.winNotZero) delete params.winNotZero;
        loading = true;
        try {
            const response = await backend.trx.list(params);
            loading = false;
            const data = response.data;
            const originalList = Array.isArray(data.list) ? data.list : [];
            transations = {
                ...transations,
                ...data,
                list: originalList,
                total: data.total ?? transations.total
            };
            if (transations.info) {
                try {
                    transactionInfo = transations.info;
                } catch (error) {
                    console.error("Error al convertir info de JSON a objeto:", error);
                }
            }
        } catch (error) {
            loading = false;
            alertify.error("Error al listar");
            if (transations.list?.game == null) {
                alertify.error("Error: el campo Game es NULL");
            }
        }
        filters.page = 1;
    };
    const onPageClick = (page) => {
        filters.page = page;
        list();
    };
    function applyRightAlignToColumns(ws, colNames = []) {
        if (!ws || !ws['!ref']) return;
        const range = utils.decode_range(ws['!ref']);
        const firstRow = range.s.r;
        const colIndexes = {};
        for (let C = range.s.c; C <= range.e.c; ++C) {
            const cellAddress = utils.encode_cell({ c: C, r: firstRow });
            const cell = ws[cellAddress];
            if (!cell) continue;
            const header = String(cell.v || "").trim();
            if (colNames.includes(header)) colIndexes[header] = C;
        }
        if (Object.keys(colIndexes).length === 0) return;
        for (let R = firstRow + 1; R <= range.e.r; ++R) {
            for (const header of Object.keys(colIndexes)) {
                const C = colIndexes[header];
                const addr = utils.encode_cell({ c: C, r: R });
                const cell = ws[addr];
                if (!cell) continue;
                if (typeof cell.v === "string" && !isNaN(Number(cell.v))) {
                    cell.v = Number(cell.v);
                    cell.t = 'n';
                }
                cell.s = cell.s || {};
                cell.s.alignment = cell.s.alignment || {};
                cell.s.alignment.horizontal = "right";
            }
        }
    }
    async function exportXLSX() {
        try {
            exportLoading = true;
            if (!isDateRangeValid()) {
                alertify.error(`No se puede exportar: el rango entre Desde y Hasta no puede superar ${MAX_DAYS} días.`);
                enforceMaxRangeFromTo();
                return;
            }
            const filename = `report_${filters.provider || 'all'}_${filters.brand || 'all'}_${filters.from}_${filters.to}.xlsx`;
            const data = Array.isArray(summary) ? summary : [];
            if (!data.length) {
                alert("No hay datos en la tabla para exportar.");
                return;
            }
            const rows = data.map(r => {
                let rowObj = {
                    Sitio: r.siteName ?? "",
                    Categoría: r.category ?? "",
                };
                if (showProvidersDetail) {
                    rowObj["Proveedor"] = (typeof providerName === "function") ? (providerName(r.provider) ?? r.provider ?? "") : (r.provider ?? "");
                }
                rowObj["Marca"] = r.brand ?? "";
                rowObj["Moneda"] = r.currency ?? "";
                rowObj["Ventas"] = Number(r.sales ?? 0);
                rowObj["Premios"] = Number(r.prizes ?? 0);
                rowObj["Devoluciones"] = Number(r.refunds ?? 0);
                rowObj["GGR"] = Number(r.ggr ?? 0);
                rowObj["GGR(USD)"] = Number(r.ggrUsd ?? 0);

                return rowObj;
            });
            const totalsCSV = data.reduce((acc, r) => {
                acc.sales += Number(r?.sales ?? 0);
                acc.prizes += Number(r?.prizes ?? 0);
                acc.refunds += Number(r?.refunds ?? 0);
                acc.ggr += Number(r?.ggr ?? 0);
                acc.ggrUsd += Number(r?.ggrUsd ?? 0);
                return acc;
            }, { sales: 0, prizes: 0, refunds: 0, ggr: 0, ggrUsd: 0 });
            let totalRow = {
                Sitio: "Total",
                Categoría: "",
            };
            if (showProvidersDetail) {
                totalRow["Proveedor"] = "";
            }
            totalRow["Marca"] = "";
            totalRow["Moneda"] = "";
            totalRow["Ventas"] = totalsCSV.sales;
            totalRow["Premios"] = totalsCSV.prizes;
            totalRow["Devoluciones"] = totalsCSV.refunds;
            totalRow["GGR"] = totalsCSV.ggr;
            totalRow["GGR(USD)"] = totalsCSV.ggrUsd;
            rows.push(totalRow);
            const ws = utils.json_to_sheet(rows, { cellDates: false });
            const colsConfig = [
                { wpx: 160 }, // Sitio
                { wpx: 100 }, // Categoría
            ];
            if (showProvidersDetail) {
                colsConfig.push({ wpx: 120 }); // Proveedor
            }
            colsConfig.push(
                { wpx: 100 }, // Marca
                { wpx: 70 },  // Moneda
                { wpx: 100 }, // Ventas
                { wpx: 100 }, // Premios
                { wpx: 110 }, // Devoluciones
                { wpx: 100 }, // GGR
                { wpx: 110 }  // GGR(USD)
            );
            ws['!cols'] = colsConfig;
            applyRightAlignToColumns(ws, ["Ventas", "Premios", "Devoluciones", "GGR", "GGR(USD)"]);
            const wb = utils.book_new();
            utils.book_append_sheet(wb, ws, "RESUMEN");
            writeFileXLSX(wb, filename, { bookType: "xlsx" });
        } catch (e) {
            console.error("Error al exportar XLSX:", e);
            alert("Error al exportar XLSX: " + (e?.message ?? e));
        } finally {
            exportLoading = false;
        }
    }
    onMount(async () => {
        let actualDate = moment();
        let dateRest = actualDate.subtract(0, "days");
        filters.from = dateRest.format("YYYY-MM-DD");
        filters.to = moment().format("YYYY-MM-DD");
        sessionClientCodes = getClientCodesFromSession();
        if (sessionClientCodes.length > 0) {
            filters.selectedClient = sessionClientCodes[0];
            filters.client_code = sessionClientCodes[0];
        } else {
            filters.client_code = "";
            filters.selectedClient = "";
        }
        try {
            const codes = sessionClientCodes;
            const res = await backend.client.list({ xpage: 500, page: 1 });
            const list = res.data?.list ?? res.data ?? [];
            clientOptions = codes.map(code => {
                const found = Array.isArray(list) ? list.find(c => c.code === code) : null;
                return { code, namesite: found?.namesite || found?.businessname || code };
            });
            if (filters.selectedClient) {
                const opt = clientOptions.find(o => o.code === filters.selectedClient);
                if (opt) clientSearch = `${opt.namesite} (${opt.code})`;
            }
        } catch {}
        const initialClient = sessionClientCodes.length > 0 ? sessionClientCodes[0] : null;
        await checkClientEndpoint(initialClient);
        await listCategories(initialClient);
        await listProviders(initialClient);
        isInitialized = true;
        loadSummary();
    });
</script>

<div class="bo-main">
    <div class="bo-filters">
        <div class="bo-filter-grid">
            <div class="bo-field">
                <label for="from">Desde</label>
                <input id="from" class="form-control" type="date"
                       bind:value={filters.from}
                       on:change={() => { enforceMaxRangeFromTo(); loadSummary(); }} />
            </div>
            <div class="bo-field">
                <label for="to">Hasta</label>
                <input id="to" class="form-control" type="date"
                       bind:value={filters.to}
                       on:change={() => { enforceMaxRangeFromTo(); loadSummary(); }} />
            </div>

            {#if sessionClientCodes.length > 1}
                <div class="bo-field" style="position:relative;">
                    <label for="clientSearch">Filtrar sitio</label>
                    <input id="clientSearch" class="form-control" type="text"
                           bind:value={clientSearch}
                           on:focus={() => { clientDropdownOpen = true; clientSearch = ''; }}
                           on:blur={() => setTimeout(() => {
                               clientDropdownOpen = false;
                               if (filters.selectedClient) {
                                   const opt = clientOptions.find(o => o.code === filters.selectedClient);
                                   if (opt) clientSearch = `${opt.namesite} (${opt.code})`;
                               } else clientSearch = 'Todos';
                           }, 200)}
                           placeholder="Buscar sitio..." />
                    {#if clientDropdownOpen}
                        <div class="search-dropdown">
                            <button class="search-dropdown-item" class:active={filters.selectedClient === ""}
                                        on:mousedown={() => selectClient("")}>
                                    <span class="opt-name">Todos</span>
                            </button>
                            {#each filteredClientOptions as opt}
                                <button class="search-dropdown-item" class:active={opt.code === filters.selectedClient}
                                        on:mousedown={() => selectClient(opt.code)}>
                                    <span class="opt-name">{opt.namesite}</span>
                                    <span class="opt-code">{opt.code}</span>
                                </button>
                            {/each}
                        </div>
                    {/if}
                </div>
            {/if}

            {#if showProvidersDetail}
                <div class="bo-field">
                    <label for="provider">Proveedor</label>
                    <select id="provider" class="form-control" bind:value={filters.provider} on:change={() => { loadBrands(filters.provider); loadSummary(); }}>
                        <option value="">Todos</option>
                        {#each providers as p}
                            <option value={p.code}>{p.name}</option>
                        {/each}
                    </select>
                </div>
            {/if}

            <div class="bo-field">
                <label for="categories">Categoría</label>
                <select id="categories" bind:value={filters.category} class="form-control" on:change={loadSummary}>
                    <option value="">Todos</option>
                    {#each categories as category}
                        <option>{category}</option>
                    {/each}
                </select>
            </div>

            <div class="bo-field">
                <label for="brand">Marca</label>
                <select id="brand" bind:value={filters.brand} class="form-control" on:change={loadSummary}>
                    <option value="">Todas</option>
                    {#each brands as b}
                        <option value={b}>{b}</option>
                    {/each}
                </select>
            </div>
            <div class="bo-actions">
                <button on:click={loadSummary} class="btn btn-primary btn-sm btn-icon">
                    {@html ICONS.search}
                </button>
                <button on:click={exportXLSX} class="btn btn-success btn-sm" disabled={exportLoading}>
                    {exportLoading ? 'Exportando...' : 'Exportar en Excel'}
                </button>
            </div>
        </div>
    </div>

    <div class="bo-body-table-trx">
        <Loading bind:loading />
        {#if !loading}
            <div style="overflow-x: auto;">
                <table class="table table-striped table-sm">
                    <thead class="table-dark">
                    <tr class="bo-table-title">
                        <th>Sitio</th>
                        <th>Categoría</th>
                        {#if showProvidersDetail}
                            <th>Proveedor</th>
                        {/if}
                        <th>Marca</th>
                        <th>Moneda</th>
                        <th>Ventas</th>
                        <th>Premios</th>
                        <th>Devoluciones</th>
                        <th>GGR</th>
                        <th>GGR(USD)</th>
                    </tr>
                    </thead>
                    <tbody>
                    {#if summary.length}
                        {#each summary as r}
                            <tr class="bo-table-data">
                                <td>{r.siteName}</td>
                                <td>{r.category}</td>
                                {#if showProvidersDetail}
                                    <td>{providerName(r.provider)}</td>
                                {/if}
                                <td>{r.brand}</td>
                                <td>{r.currency}</td>
                                <td class="col-num">{Number(r.sales).toFixed(2)}</td>
                                <td class="col-num">{Number(r.prizes).toFixed(2)}</td>
                                <td class="col-num">{Number(r.refunds).toFixed(2)}</td>
                                <td class="col-num fw-bold"><p class={clsBySign(r.ggr)}>{fmt(r.ggr)}</p></td>
                                <td class="col-num fw-bold"><p class={clsBySign(r.ggrUsd)}>{fmt(r.ggrUsd)}</p></td>
                            </tr>
                        {/each}
                        <tr class="bo-table-total">
                            <td colspan={showProvidersDetail ? "5" : "4"} class="text-end fw-bold">Total</td>
                            <td class="col-num fw-bold">{fmt(totals.sales)}</td>
                            <td class="col-num fw-bold">{fmt(totals.prizes)}</td>
                            <td class="col-num fw-bold">{fmt(totals.refunds)}</td>
                            <td class="col-num fw-bold"><p class={clsBySign(totals.ggr)}>{fmt(totals.ggr)}</p></td>
                            <td class="col-num fw-bold"><p class={clsBySign(totals.ggrUsd)}>{fmt(totals.ggrUsd)}</p></td>
                        </tr>
                    {:else}
                        <tr class="bo-table-data"><td colspan="10">Sin datos</td></tr>
                    {/if}
                    </tbody>
                </table>
            </div>
            {#if transations.list.length}
                <Pagination
                        bind:total={transations.total}
                        bind:xpage={transations.xpage}
                        bind:current={transations.page}
                        {onPageClick}
                />
            {/if}
        {/if}
    </div>
</div>

{#if showTrxLogs}
    <ViewLogs bind:showTrxLogs bind:logfilter />
{/if}

{#if showFindLogs}
    <FindLogs bind:showFindLogs />
{/if}

{#if showTrxInfo}
    <Information bind:showTrxInfo bind:transactionInfo />
{/if}

{#if showLogTrace}
    <LogTrace bind:showLogTrace bind:logfilter />
{/if}

<style>
    :root {
        --gap-sm: 0.4rem;
        --gap-md: 0.6rem;
        --gap-lg: 1rem;
        --control-h: 36px;
    }
    *,
    *::before,
    *::after { box-sizing: border-box; }
    .bo-main {
        padding: 1rem;
        display: flex;
        flex-direction: column;
        gap: var(--gap-lg);
    }
    .bo-filters {
        padding: 0.5rem 0.5rem 0;
    }
    .bo-filter-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: var(--gap-md);
    }
    .bo-field {
        display: flex;
        flex-direction: column;
        gap: 0.25rem;
        min-width: 0;
    }
    .bo-field > label {
        font-size: 0.8rem;
        color: #444;
        line-height: 1;
    }
    .bo-field .form-control {
        height: var(--control-h);
    }
    .bo-actions {
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        gap: var(--gap-sm);
        padding-top: 0.2rem;
    }
    .bo-actions .btn.btn-sm {
        height: var(--control-h);
        min-width: 44px;
    }
    .btn-icon {
        display: inline-grid;
        place-items: center;
        width: var(--control-h);
        padding: 0;
    }
    .table.table-sm th {
        padding: 0.4rem 0.6rem;
    }
    .table.table-sm td {
        padding: 0.55rem 0.6rem;
    }
    thead.table-dark {
        position: sticky;
        top: 0;
        z-index: 1;
    }
    .bo-table-title {
        text-align: center;
        font-size: 0.8rem;
        background-color: rgb(158, 93, 80);
        color: #fff;
        border: 1px solid #000;
    }
    .bo-table-data {
        text-align: center;
        font-size: 0.8rem;
    }
    .col-num {
        font-variant-numeric: tabular-nums;
        text-align: right;
    }
    .col-num p {
        margin: 0;
        text-align: right;
    }
    .text-red { color: red; }
    .text-green { color: green; }
    .bo-body-table-trx {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        position: relative;
    }
    .bo-table-total {
        text-align: right;
    }
    .bo-table-total td {
        padding: 0.55rem 0.6rem;
        text-align: right;
    }
    .text-end { text-align: right; padding-right: 0.6rem; }

    .search-dropdown {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        background: #fff;
        border: 1px solid #ced4da;
        border-radius: 0.3rem;
        max-height: 220px;
        overflow-y: auto;
        z-index: 100;
        box-shadow: 0 4px 12px rgba(0,0,0,0.12);
    }
    .search-dropdown-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding: 0.4rem 0.6rem;
        border: none;
        background: none;
        cursor: pointer;
        font-size: 0.82rem;
        text-align: left;
    }
    .search-dropdown-item:hover,
    .search-dropdown-item.active { background: #f0f0f0; }
    .opt-name { font-weight: 600; color: #212529; }
    .opt-code { color: #0d6efd; font-size: 0.75rem; font-family: monospace; }
</style>

